import { FC } from 'react';
import { RouteRedirect } from 'modules/routing-module';

export const Users: FC = () => <RouteRedirect routeKey="UsersList" />;
